import { render, staticRenderFns } from "./security.vue?vue&type=template&id=e67bc492&scoped=true&"
import script from "./security.vue?vue&type=script&lang=js&"
export * from "./security.vue?vue&type=script&lang=js&"
import style0 from "../less/profileSettings.less?vue&type=style&index=0&id=e67bc492&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67bc492",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e67bc492')) {
      api.createRecord('e67bc492', component.options)
    } else {
      api.reload('e67bc492', component.options)
    }
    module.hot.accept("./security.vue?vue&type=template&id=e67bc492&scoped=true&", function () {
      api.rerender('e67bc492', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/profileSettings/pages/security.vue"
export default component.exports